import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { AnnouncementService, ChildQuery, ChildService } from '@fgb/core';
import { ScreenType } from '@fgb/portal-component-library/src/lib/directives';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { BehaviorSubject, firstValueFrom, Subscription, zip } from 'rxjs';
import { filter, map } from 'rxjs/operators';

@Component({
  selector: 'fgb-guardian-page',
  templateUrl: './guardian-page.component.html',
  styleUrls: ['./guardian-page.component.scss'],
})
export class GuardianPageComponent implements OnInit, OnDestroy {
  @Input() membershipOptions: any;
  guardianLoadingSubject: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  isGuardian: boolean;
  isLoaded: boolean;
  isGuardianSubscription: Subscription;
  screenType = ScreenType;

  constructor(
    private childQuery: ChildQuery,
    private childService: ChildService,
    private modalService: NgbModal,
    private announcementService: AnnouncementService
  ) {}

  ngOnInit() {
    firstValueFrom(zip([this.childService.fetchGuardian(), this.announcementService.fetchAnnouncements()]));
    this.isGuardianSubscription = this.childQuery
      .selectGuardian()
      .pipe(
        filter((val) => val !== undefined),
        map((guardian) => !!guardian)
      )
      .subscribe((isGuardian) => {
        this.isGuardian = isGuardian;
        // Set loaded to true, we dont want to show the none guardian template when page is loaded
        this.isLoaded = true;
      });
  }

  ngOnDestroy(): void {
    if (this.isGuardianSubscription) {
      this.isGuardianSubscription.unsubscribe();
    }
  }

  becomeGuardian(): void {
    firstValueFrom(this.childService.registerAsGuardian());
  }

  confirmRegisterModal(content: any) {
    this.modalService.open(content, { size: 'md', centered: true, modalDialogClass: 'guardian-register-modal' });
  }
}
